<template>
  <div>
    <menuFilter ref="menuFilter" @initScreen="initScreen()"></menuFilter>
    <v-divider></v-divider>
    <lineChartLoader v-show="!vShow"></lineChartLoader>
    <v-row dense v-show="vShow">
      <v-col cols="12" sm="8" md="8">
        <LineChart></LineChart>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <ChartList v-if="vShow"></ChartList>
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <v-row v-if="vShow" justify="space-around">
      <v-col cols="12">
        <v-tabs v-model="tab" background-color="white" color="#d32f2f" dark>
          <v-tab v-for="item in items" :key="item.tab">{{ item.tab }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item v-for="item in items" :key="item.tab">
            <v-card flat>
              <v-row justify="space-around" v-if="item.tab == 'Acessos'">
                <v-col cols="12" sm="4" lg="4">
                  <FuncionalidadeUtilizadas />
                </v-col>
                <v-col cols="12" sm="8" lg="8">
                  <MediaAcessoUsuarios />
                </v-col>
                <v-col cols="12" sm="12" lg="12" v-if="true">
                  <PercentualAcessoUsuarios />
                  <!-- <ColaboradorUsuarios /> -->
                </v-col>
              </v-row>
              <v-row justify="space-around" v-if="item.tab == 'Simulações'">
                <v-col cols="12" sm="6" lg="6">
                  <SimulacaoFinanciamento />
                </v-col>
                <v-col cols="12" sm="6" lg="6">
                  <SimulacaoConsorcio />
                </v-col>
                <v-col cols="12" sm="12" lg="12">
                  <CompartilhamentoSimulacoes />
                </v-col>
              </v-row>
              <v-row justify="space-around" v-if="item.tab == 'Leads'">
                <v-col cols="12" sm="12" lg="12">
                  <Leads />
                </v-col>
              </v-row>
              <v-row justify="space-around" v-if="item.tab == 'Outros'">
                <v-col cols="12" sm="6" lg="6">
                  <Materiais />
                </v-col>
                <v-col cols="12" sm="6" lg="6">
                  <Comissao />
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
const moment = require("moment");
import { mapActions, mapGetters } from "vuex";
export default {
  name: "AppAnalytics",
  data() {
    return {
      vShow: false,
      tab: null,
      items: [
        { tab: "Acessos" },
        { tab: "Simulações" },
        { tab: "Leads" },
        { tab: "Outros" }
      ]
    };
  },

  components: {
    lineChartLoader: () =>
      import("./navigation/components/loader/lineChartLoader.vue"),
    LineChart: () => import("./navigation/lineChart.vue"),
    ChartList: () => import("./navigation/chartList.vue"),
    menuFilter: () => import("./navigation/components/filter/menuFilter.vue"),

    ColaboradorUsuarios: () =>
      import("./navigation/components/detailCompany/ColaboradorUsuarios"),
    MediaAcessoUsuarios: () =>
      import("./navigation/components/detailCompany/MediaAcessoUsuarios"),
    PercentualAcessoUsuarios: () =>
      import("./navigation/components/detailCompany/PercentualAcessoUsuarios"),
    FuncionalidadeUtilizadas: () =>
      import("./navigation/components/detailCompany/FuncionalidadeUtilizadas"),
    SimulacaoFinanciamento: () =>
      import("./navigation/components/detailCompany/SimulacaoFinanciamento"),
    SimulacaoConsorcio: () =>
      import("./navigation/components/detailCompany/SimulacaoConsorcio"),
    CompartilhamentoSimulacoes: () =>
      import(
        "./navigation/components/detailCompany/CompartilhamentoSimulacoes"
      ),
    Leads: () => import("./navigation/components/detailCompany/Leads"),
    Materiais: () => import("./navigation/components/detailCompany/Materiais"),
    Comissao: () => import("./navigation/components/detailCompany/Comissao")
  },

  methods: {
    ...mapActions("appAnalytics", ["setFilter"]),
    initScreen() {
      this.vShow = !this.vShow;
    },
    initDate() {
      const dt = moment();
      const date_init = moment().format("YYYY-MM-DD");
      const date_end = dt.subtract(7, "days").format("YYYY-MM-DD");
      this.setFilter({
        withCompany: false,
        empresas: [],
        date: [date_end, date_init]
      });
    }
  },
  beforeMount() {
    this.initDate();
  }
};
</script>

<style scoped>
.v-tab:not(.v-tab--active) {
  color: #d32f2f !important;
}
</style>
